module.exports = __webpack_public_path__ + "static/media/features-share.cde28788.png";